let activeTabIdProvider: (() => string | undefined) | null = null;

export function setActiveTabIdProvider(
  provider: (() => string | undefined) | null,
): void {
  activeTabIdProvider = provider;
}

export function getActiveTabId(): string | undefined {
  return activeTabIdProvider?.();
}
